<template>
  <q-badge
    rounded
    :color="meta.color"
    class="status-badge"
    :class="{ 'status-badge--compact': compact }"
  >
    <q-icon :name="meta.icon" class="q-mr-xs" />
    {{ meta.label }}
  </q-badge>
</template>

<script>
const STATUS_META = {
  MATCH: { label: "Совпадает", color: "positive", icon: "check_circle" },
  DIFFERENCE: { label: "Расхождение методик", color: "negative", icon: "difference" },
  REVIEW: { label: "Нужна проверка", color: "warning", icon: "rule" },
  COMPLEX_SCOPE: { label: "Сверка по ЖК", color: "indigo", icon: "hub" },
  NO_USP_DUMP: { label: "Нет дампа УСП", color: "grey-7", icon: "cloud_off" },
};

export default {
  name: "UspReportStatusBadge",
  props: {
    status: { type: String, default: "REVIEW" },
    compact: Boolean,
  },
  computed: {
    meta() {
      return STATUS_META[this.status] || STATUS_META.REVIEW;
    },
  },
};
</script>

<style scoped>
.status-badge { padding: 6px 9px; white-space: nowrap; }
.status-badge--compact { padding: 4px 7px; font-size: 10px; }
</style>
